import React, { Component } from 'react';
import Leftbar from '../Common/Leftbar/leftbar';
import Footer from '../Common/Footer';
import {
  getSubscriptionPlans,
  changeSubscriptionPlan,
  createCheckoutSession,
  getData,
  cancelSubscription,
} from '../../store/actions';
import Loader from '../Loader';
import responseMessages from '../../response.json';
import Cookies from 'universal-cookie';

// FOR ENFINITE ERROR----------------

import { loadStripe } from '@stripe/stripe-js';
import { loggerHandleFunction } from '../../utils/loggerHandleFunction';
let publicKey =
  'pk_test_51IFyDZEDuTvjQN9ipi8YVLqRiVg40DkluvO1ZViW80yyUp9X3HnIfZV14ZQGcvlxD6A7zGkiIZjwJc9Is1gGCQ5C00fOwIlV2h';

if (process.env.REACT_APP_HOST_ENV === 'production') {
  publicKey =
    'pk_live_51IFyDZEDuTvjQN9iQZi6gyl0GxIqrLJ6gT3ZXTQs31Gj0Vws8aPjlSz2ht2tSVhaZd6AAkbVDtDgKc9WSdKdKTwt00r4I6WuwU';
}
const stripePromise = loadStripe(publicKey);

// FOR ENFINITE ERROR----------------

const cookie = new Cookies();

class SubscriptionPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      subscriptionPlanModal: true,
      checkoutModal: false,
      downgradePlanModal: false,
      downgradeSuccessModal: false,
      clinicId:
        cookie.get('user', { path: '/' }) &&
        cookie.get('user', { path: '/' }).clinicId
          ? cookie.get('user', { path: '/' }).clinicId
          : '',
      clinicDetail: cookie.get('clinic', { path: '/' }) || {},
      subscriptionPlans: [],
      currentPlan: {},
      selectedPlan: {},
    };
  }

  componentWillMount() {
    this.handleFetchClinic();
    this.handleFetchData();
  }

  componentDidMount() {
    setTimeout(() => {
      document.getElementById('subscription-box').classList.add('show');
    }, 100);
  }

  async handleFetchClinic() {
    let { clinicId } = this.state;
    await getData('clinics', clinicId, async (err, clinicRes) => {
      if (err) {
        loggerHandleFunction(err);
      }
      cookie.set('clinic', clinicRes || {}, { path: '/' });
      this.setState({ clinicDetail: clinicRes });
    });
  }

  async handleFetchData() {
    let { clinicDetail } = this.state;
    await getSubscriptionPlans(async (err, planRes) => {
      if (err) {
        loggerHandleFunction(err);
      }

      let subscriptionPlans = planRes;
      //console.log(subscriptionPlans);
      let currentPlan =
        planRes && planRes.find((p) => p.name == clinicDetail.subscriptionPlan);
      this.setState({ currentPlan, subscriptionPlans, isLoading: false });
    });
  }

  async handlePlanChange() {
    this.setState({ isLoading: true });
    let { clinicDetail, clinicId, selectedPlan } = this.state;

    if (selectedPlan && !selectedPlan.priceId) {
      if (clinicDetail.subscriptionId) {
        await cancelSubscription(clinicDetail.subscriptionId, clinicId);
      }
      await changeSubscriptionPlan(clinicId, selectedPlan);
      this.setState({ isLoading: false });
      if (this.state.downgradePlanModal)
        this.setState({
          downgradeSuccessModal: true,
          downgradePlanModal: false,
        });
    } else {
      const stripe = await stripePromise;
      clinicDetail.clinicId = clinicId;
      console.log(selectedPlan, 'select plan');
      let sessionId = await createCheckoutSession(clinicDetail, selectedPlan);
      console.log('sessionId:', sessionId);
      this.setState({ isLoading: false });
      const result = await stripe.redirectToCheckout({
        sessionId: sessionId,
      });
      if (result.error) {
        console.log('Error:', result.error);
      }
    }
    document.getElementById('subscription-box') &&
      document.getElementById('subscription-box').classList.remove('show');
    document.getElementById('subscription-box-downgrade') &&
      document
        .getElementById('subscription-box-downgrade')
        .classList.remove('show');
    setTimeout(() => {
      this.props.hidePopup();
    }, 100);
  }

  render() {
    let {
      subscriptionPlanModal,
      checkoutModal,
      downgradePlanModal,
      downgradeSuccessModal,
      subscriptionPlans,
      currentPlan,
    } = this.state;
    return (
      <div>
        <div className="dashboard">
          {subscriptionPlanModal ? (
            <div
              className="step-wrapper common-pop subscription-pop popup-common-class fade d-block"
              id="subscription-box"
            >
              {this.state.isLoading ? (
                <div className="custm-loader">
                  <Loader></Loader>
                </div>
              ) : null}
              <div className="patient-pop-outer">
                <div className="patient-pop-box">
                  <div className="step-outter">
                    <div className="subscription-pop-inner animate-box">
                      <div
                        className="pop-close-cross"
                        onClick={() => {
                          document
                            .getElementById('subscription-box')
                            .classList.remove('show');
                          setTimeout(() => {
                            this.props.hidePopup();
                          }, 100);
                        }}
                      >
                        <img src="/assets/img/exit.png" alt="exit" />
                      </div>
                      <div className="subscription-pop-head">
                        <h2>Choose Your Subscription Plan</h2>
                        <p>Select a plan that works for your clinic.</p>
                        <p>
                          Unlock your full potential - Upgrade now to basic or premium and enjoy exclusive features, premium support, and a <b>5% discount for 3 Months</b> when you upgrade today!
                        </p>
                      </div>
                      
                      <div className="subscription-plan-list">
                        {subscriptionPlans && subscriptionPlans.length > 0
                          ? subscriptionPlans.map((plan, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`subscription-plan-box ${
                                    currentPlan &&
                                    plan.name === currentPlan.name
                                      ? 'small-plan-box'
                                      : ''
                                  }`}
                                >
                                    {plan.isAnnualBilling && plan.saveAnnualPayment && plan.priceAnnually ? 
                                    <div className='relative'>
                                      <span className='subscription-plan-name'>{plan && plan.displayName} Plan</span>
                                      <div className='subscription-annual-plan'>
                                        <span class="subscription-annual-plan-save">Save ${plan.saveAnnualPayment} - </span>
                                         with annual billing <span className='annual-price'>${plan.priceAnnually}/year</span>
                                      </div>
                                    </div>
                                     : 
                                     <div className="subscription-plan-name">
                                     {plan && plan.displayName} Plan
                                   </div>}
                                  <div className="subscription-plan-price" style={{ marginTop: plan.isAnnualBilling && plan.saveAnnualPayment && plan.priceAnnually ? '4px' : '60px' }}>
                                    ${plan && plan.price}
                                  </div>
                                  <div className="subscription-plan-description">
                                    <b>{plan.details}</b>
                                    <br /> <br />
                                    {plan?.description}
                                    {/* Coordinate care for {plan.patientCount}{' '}
                                    patients.
                                    <br /> Contribute to existing care plans.
                                    <br />
                                    Track patient progress
                                    <br />
                                    Communicate with the care team */}
                                    <br />
                                    <b>{plan.videoText}</b>
                                  </div>
                                  {currentPlan &&
                                  plan.name === currentPlan.name ? (
                                    <button
                                      className={`log-btn step-btn free-plan-btn ${
                                        currentPlan &&
                                        plan.name === currentPlan.name
                                          ? 'disable-btn'
                                          : ''
                                      }`}
                                      disabled={
                                        currentPlan &&
                                        plan.name === currentPlan.name
                                      }
                                    >
                                      Current Plan
                                    </button>
                                  ) : currentPlan &&
                                    plan.priority < currentPlan.priority ? (
                                    <button
                                      className="log-btn step-btn free-plan-btn"
                                      onClick={() => {
                                        document
                                          .getElementById('subscription-box')
                                          .classList.remove('show');
                                        setTimeout(() => {
                                          this.setState(
                                            {
                                              subscriptionPlanModal: false,
                                              selectedPlan: plan,
                                              downgradePlanModal: true,
                                            },
                                            () => {
                                              setTimeout(() => {
                                                document
                                                  .getElementById(
                                                    'subscription-box-downgrade'
                                                  )
                                                  .classList.add('show');
                                              }, 100);
                                            }
                                          );
                                        }, 100);
                                      }}
                                    >
                                      Downgrade Plan
                                    </button>
                                  ) : (
                                    <button
                                      className="log-btn step-btn free-plan-btn"
                                      onClick={() => {
                                        this.setState(
                                          { selectedPlan: plan },
                                          () => {
                                            this.handlePlanChange();
                                          }
                                        );
                                      }}
                                    >
                                      Select Plan
                                    </button>
                                  )}
                                </div>
                              );
                            })
                          : ''}

                        {/* <div className="subscription-plan-box small-plan-box">
                          <div className="subscription-plan-name">
                            Small Clinic
                          </div>
                          <div className="subscription-plan-price">
                            $79<span>/Month</span>
                          </div>
                          <div className="subscription-plan-description">
                            Custom solutions that suit your clinic Create &
                            coordinate conditions Contribute to existing
                            conditions Practice nurse access Track patient
                            progress Recall automation Paperless referrals Care
                            plan distribution
                          </div>
                          <button className="log-btn step-btn orange-btn small-plan-btn select-plan-btn">
                            Select Plan
                          </button>
                        </div>
                        <div className="subscription-plan-box">
                          <div className="subscription-plan-name">
                            Large Clinic
                          </div>
                          <div className="subscription-plan-price">
                            Let’s Talk
                          </div>
                          <div className="subscription-plan-description">
                            Custom solutions that suit your clinic Create &
                            coordinate conditions Contribute to existing
                            conditions Practice nurse access Track patient
                            progress Recall automation Paperless referrals Care
                            plan distribution
                          </div>
                          <button className="log-btn step-btn large-plan-btn select-plan-btn">
                            Select Plan
                          </button>
                        </div> */}
                      </div>
                      {this.props.isNextButton ?
                          <div className="d-flex justify-content-center">
                            <div className="form-group" style={{ width: '40%'}}>
                              <button className="log-btn step-btn free-plan-btn" onClick={() => this.props.showButtonAction()}>
                                Next
                              </button>
                            </div>
                          </div> 
                       
                      : <></>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {checkoutModal ? (
            <div className="step-wrapper common-pop checkout-pop popup-common-class">
              <div className="patient-pop-outer">
                <div className="patient-pop-box">
                  <div className="step-outter">
                    <div className="three-steps">
                      <div className="step-top">
                        <div className="step-nav">
                          <a href="#" className="step1-back">
                            <img
                              src="/assets/img/back.png"
                              className="img img-fluid"
                            />
                          </a>
                          <a href="#" className="pop-close-cross">
                            <img
                              src="/assets/img/exit.png"
                              className="img img-fluid"
                            />
                          </a>
                        </div>
                        <div className="step-progress">
                          <div className="step-p-text">
                            <h4>Checkout</h4>

                            <span>Step 1 of 2</span>
                          </div>
                          <div className="progress">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{ width: '50%' }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div className="step-bottom">
                        <div className="step-1">
                          <div className="checkout-form">
                            <div className="checkout-summary">
                              <div className="summary-detail">
                                <h3>Summary</h3>
                                <div className="summary-detail-box">
                                  <div className="summary-detail-sec">
                                    <label>Plan Details</label>
                                    <p>Small Clinic</p>
                                  </div>
                                  <div className="summary-detail-sec">
                                    <label>Num. of Users</label>
                                    <p>10</p>
                                  </div>
                                  <div className="summary-detail-sec">
                                    <label>Payment Terms</label>
                                    <p>Monthly</p>
                                  </div>
                                </div>
                                <div className="checkout-price">
                                  <label>Total</label>
                                  <p>$79.00</p>
                                </div>
                              </div>
                              <h3>Payment</h3>
                              <div className="summary-detail payment-detail-form">
                                <div className="payment-form">
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <label>Card Number*</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Card Number*"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <label>Card Holder*</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Name on Card*"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <label>Expiry Date*</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Expiry Date*"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <label>CVV*</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="CVV*"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <p className="payment-form-error">
                                        Invalid Payment Details. Try Again.
                                      </p>
                                      <a className="forgot-pass">
                                        *Required Fields
                                      </a>
                                    </div>
                                    <div className="col-sm-12">
                                      <div className="form-group">
                                        <button className="log-btn step-btn disable-btn step2-next">
                                          Next
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="step-2">
                          <div className="checkout-txt">
                            <p>
                              Your payment has successfully been processed. We
                              have sent the receipt to:{' '}
                            </p>
                            <p>mhendricks@balwyncentralmedical.com.au</p>
                          </div>
                          <div className="checkout-form">
                            <div className="checkout-summary">
                              <div className="summary-detail">
                                <h3>Purchase Summary</h3>
                                <div className="summary-detail-box">
                                  <div className="summary-detail-sec">
                                    <label>Plan Details</label>
                                    <p>Small Clinic</p>
                                  </div>
                                  <div className="summary-detail-sec">
                                    <label>Num. of Users</label>
                                    <p>10</p>
                                  </div>
                                  <div className="summary-detail-sec">
                                    <label>Payment Terms</label>
                                    <p>Monthly</p>
                                  </div>
                                </div>
                                <div className="checkout-price">
                                  <label>Total</label>
                                  <p>$79.00</p>
                                </div>
                              </div>
                              <button className="log-btn step-btn plan-done">
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {downgradePlanModal ? (
            <div
              className="complete-condition-pop downgrade-pop popup-common-class fade d-block"
              id="subscription-box-downgrade"
            >
              {this.state.isLoading ? (
                <div className="custm-loader">
                  <Loader></Loader>
                </div>
              ) : null}
              {/* <Leftbar /> */}
              <div className="complete-condition-outer">
                <div className="complete-condition-inner animate-box">
                  <div className="complete-condition-box">
                    <div className="complete-pop-head">
                      <h3>Downgrade plan?</h3>
                      <div
                        className="complete-pop-close"
                        onClick={() => {
                          document
                            .getElementById('subscription-box-downgrade')
                            .classList.remove('show');
                          setTimeout(() => {
                            this.props.hidePopup();
                          }, 100);
                        }}
                      >
                        <span className="close-complete-pop">
                          <img src="/assets/img/exit.png" />
                        </span>
                      </div>
                    </div>
                    <div className="complete-pop-con">
                      <div className="downgrade-content">
                        <p>
                          Are you sure you want to downgrade your subscription?
                        </p>
                        <p>
                          You will lose access to your patient files . You can
                          upgrade at any time.
                        </p>
                      </div>
                      <div className="complete-pop-btn set-popup-buttons">
                        <button
                          className="btn red-transparent downgrade-continue"
                          onClick={() => {
                            document
                              .getElementById('subscription-box-downgrade')
                              .classList.remove('show');
                            setTimeout(() => {
                              this.setState(
                                {
                                  downgradePlanModal: false,
                                  downgradeSuccessModal: true,
                                },
                                () => {
                                  this.handlePlanChange();

                                  setTimeout(() => {
                                    document
                                      .getElementById('success-modal')
                                      .classList.add('show');
                                  }, 100);
                                }
                              );
                            }, 100);
                          }}
                        >
                          Continue
                        </button>
                        <button
                          className="btn blue-btn close-complete-pop"
                          onClick={() => {
                            document
                              .getElementById('subscription-box-downgrade')
                              .classList.remove('show');
                            setTimeout(() => {
                              this.props.hidePopup();
                            }, 100);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {downgradeSuccessModal ? (
            <div
              className="step-wrapper common-pop downgrade-success-pop popup-common-class fade d-block"
              id="success-modal"
            >
              <div className="patient-pop-outer">
                <div className="patient-pop-box animate-box">
                  <div className="step-outter">
                    <div className="three-steps">
                      <div className="step-top">
                        <div className="step-progress">
                          <div className="step-p-text">
                            <h4>Plan downgraded</h4>
                          </div>
                          <div className="success-patient-inner">
                            <img src="/assets/img/tick.png" />
                            <p>Your plan has been downgraded. </p>
                            <p>
                              You can re-subscribe at any time to gain access to
                              patient files.
                            </p>
                            <button
                              className="log-btn step-btn downgrade-done"
                              onClick={() => {
                                document
                                  .getElementById('success-modal')
                                  .classList.remove('show');
                                setTimeout(() => {
                                  this.props.hidePopup();
                                }, 100);
                              }}
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default SubscriptionPlan;
